export const SUGGESTION_TYPE = {
    PLATFORM: 'platform',
    CHANNEL: 'channel',
}

export const CHANNEL_MODE = {
    PRIVATE: 'private',
}